import { cloneElement, FC, ReactNode } from 'react'

import Tooltip, { TooltipProps } from '../../atoms/Tooltip'

export interface ItemWithTooltipProps {
  id: string
  item: ReactNode
  children: ReactNode
  tooltipProps?: Omit<TooltipProps, 'children' | 'id'>
  hideTooltip?: boolean
}

const ItemWithTooltip: FC<ItemWithTooltipProps> = ({
  id,
  item,
  children,
  tooltipProps,
  hideTooltip,
}) => {
  const ItemWithTooltip = hideTooltip
    ? item
    : cloneElement<any, any>(item as any, {
        'data-tip': '',
        'data-for': id,
      })

  return (
    <>
      {ItemWithTooltip}
      {!hideTooltip && (
        <Tooltip id={id} place="bottom" effect="solid" {...tooltipProps}>
          {children}
        </Tooltip>
      )}
    </>
  )
}

export default ItemWithTooltip
